export const ACADEMY_TOPIC_TYPES = {
  template: 'template',
  clone: 'clone',
  dummy: 'dummy',
};
